import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { Minicart, useEnvironmentConfig } from '@sparknz/journeys-common';
import {
  FocusHeader as PatternLibFocusHeader,
  FocusHeaderProps as PatternLibFocusHeaderProps,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import { useCartCookie, useSegment } from 'shared/hooks';
import { getSegmentCartItemCount } from 'shared/utils/cartItemCount.utils';

export interface ShopFocusHeaderProps
  extends Partial<PatternLibFocusHeaderProps> {
  showCart?: boolean;
  cartCountFromQuery?: number;
  isActionDisabled?: boolean;
  hideGoToCart?: boolean;
  onHandleReviewCartModalClick?: () => void;
}

export default function ShopFocusHeader(props: ShopFocusHeaderProps) {
  const [isMinicartOpen, setIsMinicartOpen] = useState(false);
  const router = useRouter();
  const { isBusiness } = useSegment();
  const config = useEnvironmentConfig();
  const { cartCookieName } = config;
  const { numberOfCartItems, cartSegment } = useCartCookie();

  const {
    showCart = true,
    isActionDisabled = false,
    cartCountFromQuery,
    hideGoToCart = false,
    onHandleReviewCartModalClick: onConfirmation,
  } = props;

  const handleMinicartClick = () => {
    trackCustomLink('Minicart click');
    setIsMinicartOpen((prevState) => !prevState);
  };

  const handleMinicartClose = () => {
    setIsMinicartOpen(false);
  };

  const cart = showCart
    ? {
        items:
          cartCountFromQuery ||
          getSegmentCartItemCount({
            numberOfCartItems,
            cartSegment,
            isBusiness,
          }),
        onClick: handleMinicartClick,
      }
    : null;

  return (
    <>
      <LinkRegion regionId="focusHeader" enableCloning>
        <PatternLibFocusHeader
          title=""
          onBack={router.back}
          isActionDisabled={isActionDisabled}
          cart={cart}
          {...props}
        />
      </LinkRegion>
      {showCart ? (
        <LinkRegion regionId="focusHeader">
          <Minicart
            isOpen={isMinicartOpen}
            handleClose={handleMinicartClose}
            positionRight={190}
            hideGoToCart={hideGoToCart}
            handleGoToCartClick={onConfirmation}
            cartCookieName={cartCookieName}
            shouldDisplayRemoveButton
          />
        </LinkRegion>
      ) : null}
    </>
  );
}
